import { Injectable, Inject } from '@angular/core';
import { E8HttpClientRequestContext } from './e8http-client-request.context';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { C8HttpClientOptions } from './c8-http-client-options';
import { ITokenService, DA_SERVICE_TOKEN } from '@delon/auth';
import { CacheService } from '@delon/cache';
import { C8DeaultLoading } from './c8-default-loading';
@Injectable({
    providedIn: 'root',
})
export class E8HttpClient {
    headers = new HttpHeaders({
        'Content-Type': 'application/json',
    });
    loading:boolean;
    constructor(private http: HttpClient,
        @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService,
        private  cache: CacheService,
        private   deaultLoading :C8DeaultLoading,
                // private tokenService: TokenService,
        // private authLoginSubject: AuthLoginSubject,
        // private alertController: AlertController,
        // private c8loading: C8LoadingController,
        // private events: Events
    ) {

    }

    public async post(url: string, parameter?: any, options?: C8HttpClientOptions): Promise<any> {
        options = this.getClietOptions(options);
        if (options.alertLoading) { // 打开进度条
            await options.alertLoading.loading(options.loadingMsg);
        }
        const jsonString = JSON.stringify(parameter);
        if(options.isCache){
           const res= this.cache.getNone(url+jsonString);
            // if(!environment.production){
            //     console.log(res);
            // }
           if(res){
               return res;
           }
        }
        return this.http
            .post(url, jsonString, { headers: this.getHeaders(options) })
            .toPromise()
            .then(res => {
                if(options.isCache){
                    this.cache.set(url+jsonString,res);
                }
                return res;
            }
            ).catch(error => {
                // 初始化post请求上下文 参数
                const context = new E8HttpClientRequestContext();
                context.url = url;
                context.parameter = parameter;
                context.options = options;

                return this.handleError(error, context);
            }
            ).finally(() => {
                if (options.alertLoading) {// 关闭进度条
                    options.alertLoading.loaded();
                }
            });
    }
    public async get(url: string, options?: C8HttpClientOptions): Promise<any> {
        options = this.getClietOptions(options);
        if (options.alertLoading) { // 打开进度条
            await options.alertLoading.loading();
        }
        return this.http.get(url, { headers: this.getHeaders(options) })
            .toPromise()
            .then(res => {
                return res;
            }
            ).catch(error => {
                // 初始化post请求上下文 参数
                const context = new E8HttpClientRequestContext();
                context.url = url;
                context.method = 'get';
                context.parameter = options;
                return this.handleError(error, context);
            }
            ).finally(() => {
                if (options.alertLoading) {// 关闭进度条
                    options.alertLoading.loaded();
                }
            });
    }
    public exportExcel(action: any, source: any) {
        const form: any = document.createElement('FORM');
        document.body.appendChild(form);
        form.method = 'POST';
        form["Content-Type"]="multipart/form-data";
        const createInput = document.createElement('input');
        createInput.setAttribute('type', 'hidden');
        createInput.setAttribute('name', 'source');
        createInput.value = JSON.stringify(source);
        form.appendChild(createInput);
        const headerAccessTokenElement = document.createElement('input');
        headerAccessTokenElement.setAttribute('type', 'hidden');
        headerAccessTokenElement.setAttribute('name', 'X-Access-Token');
        headerAccessTokenElement.value = this.tokenService.get().token;
        form.appendChild(headerAccessTokenElement);
        form.action = action;
        form.submit();
    }
    // export(url,body,options?: C8HttpClientOptions) {
    //     // let user_token: string = this.sessionService.getToken();
    //     // let headers = new Headers();
    //     // headers.append('Authorization', 'Bearer ' + user_token);
    //     return this.http.post(url, body,{
    //         headers: this.getHeaders(options),
    //         responseType:  'blob'
    //     })..toPromise().then(res => new Blob([res],{ type: 'application/vnd.ms-excel' }));
    // }
    private handleError(error: any, context: E8HttpClientRequestContext) {
        if (error.status === 401 && error.headers.get('showlogin') === 168168) {// 未登陆或会话超时
            // this.router.navigateByUrl("/passport/login");
            // return;
            // this.authLoginSubject.setShowLogin(); // 通知显示登陆窗体
            // return new Promise<any>(resolve => {
            //     // 订阅 登陆成功的消息
            //     const subscription = this.authLoginSubject.subscribe(s => {
            //         if (s.loginSuccess) { // 登陆成功
            //             subscription.unsubscribe(); // 取消订阅
            //             console.log('登陆成功后,重新发起数据请求');
            //             console.log(context);
            //             // 再次发起请求
            //             if (context.method === 'get') {
            //                 this.get(context.url, context.options).then(result => {
            //                     resolve(result);
            //                 });
            //             } else {
            //                 this.post(context.url, context.parameter, context.options).then(result => {
            //                     resolve(result);
            //                 });
            //             }
            //         }
            //     });
            // });
        } else if (error.status === 500) {
            this.presentAlertConfirm((error.error.message || error.message) + context.url);
        } else {
            this.presentAlertConfirm('请联系系统管理员' + (error.message || error) + context.url);
        }
        console.log(error);
        return Promise.reject(error);
    }
    private async presentAlertConfirm(message: string) {
        // const alert = await this.alertController.create({
        //     header: 'Alert!',
        //     message: message,
        //     buttons: [
        //         {
        //             text: 'Okay',
        //             handler: () => {
        //                 console.log('Confirm Okay');
        //             }
        //         }
        //     ]
        // });
        // await alert.present();
    }
    private getHeaders(options: C8HttpClientOptions) {
        if (options.headers != null) {
            return options.headers;
        }
        return this.headers;
    }


    private getClietOptions(options?: C8HttpClientOptions): C8HttpClientOptions {
        if (options) {
            if (!options.showLoading) {
                options.alertLoading = null;// this.c8loading;
            } else{
                options.alertLoading=this.deaultLoading;
            }
        } else {
            options = { alertLoading: this.deaultLoading, showLoading: true };
        }
        return options;
    }
}
